import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'

import Breadcrumb from 'components/Breadcrumb'
import Loading from 'components/Loading'

import PageTitle from './PageTitle'
import AddButton from './AddButton'
import Item from './Item'

const List = props => (
  <div className="page-content">
    {props.isLoading && (<Loading />)}
    <Breadcrumb data={props} />
    <div className="row">
      <PageTitle />
      <AddButton pathname={props.location.pathname} />
    </div>
    <div className="row">
      <div className="col-md-12">
        <div className="portlet light portlet-fit">
          <div className="portlet-title">
            <div className="caption">
              <span className="caption-subject sbold uppercase">Country Tax list</span>
            </div>
            <div className="actions">
              {props.data.totalPages > 1 && (
                <ReactPaginate
                  previousLabel={'previous'}
                  nextLabel={'next'}
                  breakLabel={<a href="">...</a>}
                  breakClassName={'break-me'}
                  pageCount={props.data.totalPages}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={2}
                  onPageChange={props.handlePageChange}
                  containerClassName={'pagination'}
                  subContainerClassName={'pages pagination'}
                  activeClassName={'active'}
                />
              )}
            </div>
          </div>
          <div className="portlet-body">
            <div className="table-scrollable table-scrollable-borderless">
              <table className="table table-hover table-light">
                <thead>
                  <tr className="uppercase">
                    <th> # </th>
                    <th> GC Country </th>
                    <th> VAT </th>
                    <th> WHT </th>
                    <th> WHT with TIN </th>
                    <th> GC fee </th>
                    <th> Processing fee </th>
                    <th style={{ width: '35%' }}> Company Details </th>
                    <th style={{ width: '25%' }}> Bank Details </th>
                    <th className="table-actions"> Actions </th>
                  </tr>
                </thead>
                <tbody>
                  { props.data.rows.map((row, key) => (
                    <Item
                      indexKey={key}
                      key={row.id}
                      row={row}
                      pathname={props.location.pathname}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

List.defaultProps = {
  location: {
    pathname: '',
  },
  data: {
    totalPages: 1,
    rows: [],
  },
  isLoading: false,
}

List.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    totalPages: PropTypes.number.isRequired,
    rows: PropTypes.array.isRequired,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  handlePageChange: PropTypes.func.isRequired,
}

export default List
